<template>
  <v-container v-if="user">
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs"/>
    </div>
    <div class="form-npa edit user-view-edit">
      <div class="position">
        <div class="bg-white p-20">
          <div class="form-head">
            <Widget position="menu_profile"/>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  v-on="on"
                  class="navbar-toggler-profile"
                >
                  {{ $t('Профиль') }} <span class="caret"></span>
                </v-btn>
              </template>
              <v-list class="navbar-collapse">
                <v-list-item>
                  <Widget position="menu_profile"/>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="view-npa-body">
            <div class="form-group">
              <div class="search-result">
                <v-dialog v-model="accessJournalDialog" max-width="940">
                  <v-card class="modal modal-user-access-journal">
                    <div class="modal-head">
                      {{ $t('Журнал доступа') }}
                      <v-btn color="modal-close" @click.native="accessJournalDialog = false">
                        <span class="pro-icon-close1"></span>
                      </v-btn>
                    </div>
                    <div class="modal-body">
                      <div class="table-overflow" v-if="accessJournals.length">
                        <table>
                          <thead>
                          <tr>
                            <td>
                              {{ $t('Логин') }}
                            </td>
                            <td>
                              {{ $t('Статус') }}
                            </td>
                            <td>
                              {{ $t('Дата') }}
                            </td>
                            <td>
                              {{ $t('Причина') }}
                            </td>
                            <td>
                              {{ $t('Комментарии') }}
                            </td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="accessJournal in accessJournals"
                              :key="accessJournal.id"
                              :style="'background-color:' + accessJournal.status.color_status"
                          >
                            <td>{{ accessJournal.user_main ? accessJournal.user_main.nick_name : '' }}</td>
                            <td>{{ accessJournal.status.transName }}</td>
                            <td class="td-date">{{ new Date(accessJournal.date) | dateFormat('DD.MM.YYYY')}}</td>
                            <td>
                              <span v-if="accessJournal.reason">
                                {{ accessJournal.reason.transName }}
                              </span>
                            </td>
                            <td>{{ accessJournal.comment }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </v-card>
                </v-dialog>
                <div class="table-overflow">
                  <table class="table">
                    <tbody>
                    <tr>
                      <th>{{ $t('Электронный адрес почты') }}</th>
                      <td>
                        <template>
                          {{ user.email }}
                        </template>
                        <!--                    <template v-else-if="editable">-->
                        <!--                      <InlineEdit-->
                        <!--                        :params="fields.email"-->
                        <!--                        @update-field="updateField($event)"-->
                        <!--                      />-->
                        <!--                    </template>-->
                        <!--                    <a-->
                        <!--                      v-if="!fields.email.showEdit && editable"-->
                        <!--                      @click="fields.email.showEdit = true"-->
                        <!--                      class="edit-btn"-->
                        <!--                    >-->
                        <!--                      <span class="pro-icon-pencil"></span>-->
                        <!--                    </a>-->
                      </td>
                    <tr>
                      <th>{{ $t('ФИО') }}</th>
                      <td>
                        <template v-if="!fields.name.showEdit">
                          {{ user.second_name }} {{ user.first_name }} {{ user.last_name }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.name"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.name.showEdit && editable"
                          @click="fields.name.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Логин') }}</th>
                      <td>
                        <template v-if="!fields.nickName.showEdit">
                          {{ user.nick_name }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.nickName"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.nickName.showEdit && editable"
                          @click="fields.nickName.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Пароль') }}</th>
                      <td>
                        <template v-if="!fields.password.showEdit">
                          <span>* * * * * * * *</span>
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.password"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.password.showEdit && editable"
                          @click="fields.password.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Роль') }}</th>
                      <td>
                        <template v-if="!fields.systemRoles.showEdit">
                          <ul v v-if="user.system_roles">
                            <li v-for="role in user.system_roles" :key="role.id">{{ role.transName }}</li>
                          </ul>
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.systemRoles"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.systemRoles.showEdit && editable"
                          @click="fields.systemRoles.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Разработчик') }}</th>
                      <td>
                        <template v-if="!fields.developer.showEdit && user.developer">
                          <v-icon
                            v-if="user.developer.status === false"
                            class="nv_icon mr-1"
                            x-small
                          />
                          {{ user.developer.transName }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.developer"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.developer.showEdit && editable"
                          @click="fields.developer.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr v-if="showInitiativeGroupField">
                      <th>{{ $t('Инициативная группа') }}</th>
                      <td>
                        <template v-if="!fields.initiativeGroup.showEdit">
                          {{ user.initiative_group ? user.initiative_group.transName : '' }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.initiativeGroup"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.initiativeGroup.showEdit && editable"
                          @click="fields.initiativeGroup.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Адрес') }}</th>
                      <td>
                        <template v-if="!fields.address.showEdit">
                          {{ user.address }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.address"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.address.showEdit && editable"
                          @click="fields.address.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Гражданство') }}</th>
                      <td>
                        <template v-if="!fields.citizenship.showEdit">
                          {{ user.citizenship ? user.citizenship.transName : '' }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.citizenship"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.citizenship.showEdit && editable"
                          @click="fields.citizenship.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Пол') }}</th>
                      <td>
                        <template v-if="!fields.sex.showEdit">
                          <template v-if="user.sex">{{ user.sex.transName }}</template>
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.sex"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.sex.showEdit && editable"
                          @click="fields.sex.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Дата рождения') }}</th>
                      <td>
                        <template v-if="!fields.birthDate.showEdit ">
                          <template v-if="user.birth_date">
                            {{ new Date(user.birth_date) | dateFormat('DD.MM.YYYY') }}
                          </template>
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.birthDate"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.birthDate.showEdit && editable"
                          @click="fields.birthDate.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Телефон') }}</th>
                      <td>
                        <template v-if="!fields.phone.showEdit">
                          {{ user.phone }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.phone"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.phone.showEdit && editable"
                          @click="fields.phone.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Изображение') }}</th>
                      <td>
                        <div class="img-circle">
                          <input
                            id="file"
                            ref="file"
                            type="file"
                            class="hide"
                            @change="handleFileUpload"
                          />
                          <template v-if="user.photo">
                            <img :src="baseUrl + user.fullFilesDirectory" alt=""/>
                            <a @click="changeAvatar" class="add-image-profile changeAvatar">{{
                              $t('Изменить картинку')
                              }}</a>
                          </template>
                          <template v-else>
                            <a class="add-image-profile" @click="changeAvatar">{{ $t('Добавить картинку') }}</a>
                          </template>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Отдел') }}</th>
                      <td>
                        <template v-if="!fields.department.showEdit">
                          {{ user.department }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.department"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.department.showEdit && editable"
                          @click="fields.department.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Должность') }}</th>
                      <td>
                        <template v-if="!fields.post.showEdit">
                          {{ user.post ? user.post.transName : '' }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.post"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.post.showEdit && editable"
                          @click="fields.post.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
<!--                    <tr>-->
<!--                      <th>{{ $t('Заблокированные разрешения ролей') }}</th>-->
<!--                      <td>-->
<!--                        <template v-if="!fields.lockedSystemRolePermissions.showEdit">-->
<!--                          <ul v v-if="user.locked_system_role_permissions">-->
<!--                            <li v-for="role in user.locked_system_role_permissions" :key="role.id">{{ role.transName }}-->
<!--                            </li>-->
<!--                          </ul>-->
<!--                        </template>-->
<!--                        <template v-else-if="editable">-->
<!--                          <InlineEdit-->
<!--                            :params="fields.lockedSystemRolePermissions"-->
<!--                            @update-field="updateField($event)"-->
<!--                          />-->
<!--                        </template>-->
<!--                        <a-->
<!--                          v-if="!fields.lockedSystemRolePermissions.showEdit && editable"-->
<!--                          @click="fields.lockedSystemRolePermissions.showEdit = true"-->
<!--                          class="edit-btn"-->
<!--                        >-->
<!--                          <span class="pro-icon-pencil"></span>-->
<!--                        </a>-->
<!--                      </td>-->
<!--                    </tr>-->
<!--                    <tr>-->
<!--                      <th>{{ $t('Дополнительные разрешения пользователя') }}</th>-->
<!--                      <td>-->
<!--                        <template v-if="!fields.permissions.showEdit">-->
<!--                          <ul v v-if="user.permissions">-->
<!--                            <li v-for="permission in user.permissions" :key="permission.id">{{ permission.transName }}-->
<!--                            </li>-->
<!--                          </ul>-->
<!--                        </template>-->
<!--                        <template v-else-if="editable">-->
<!--                          <InlineEdit-->
<!--                            :params="fields.permissions"-->
<!--                            @update-field="updateField($event)"-->
<!--                          />-->
<!--                        </template>-->
<!--                        <a-->
<!--                          v-if="!fields.permissions.showEdit && editable"-->
<!--                          @click="fields.permissions.showEdit = true"-->
<!--                          class="edit-btn"-->
<!--                        >-->
<!--                          <span class="pro-icon-pencil"></span>-->
<!--                        </a>-->
<!--                      </td>-->
<!--                    </tr>-->
                    <tr>
                      <th>
                        {{ $t('Доступ специалиста') }}
                      </th>
                      <td>
                        <ChangeAccess
                          :user="user"
                          :access="'spec'"
                          :state="user.specialist_access"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        {{ $t('Доступ админа') }}
                      </th>
                      <td>
                        <ChangeAccess
                          :user="user"
                          :access="'admin'"
                          :state="user.admin_access"
                        />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-action">
            <v-btn
              class="btn-default"
              @click="onCancel()"
              rounded
            >
              {{ $t('Закрыть') }}
            </v-btn>

            <v-btn
              class="btn-default"
              @click="accessJournalDialog = true"
              rounded
            >
              {{ $t('Журнал доступа') }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import User from '@/model/user'
  import Widget from '@/components/app/Widget'
  import InlineEdit from '@/components/user/InlineEdit'
  import ChangeAccess from '@/components/user/ChangeAccess'
  import {mapMutations} from 'vuex'
  import moment from 'moment'
  import { Trans } from "@/plugins/Translation"

  export default {
    components: {
      Widget,
      InlineEdit,
      ChangeAccess
    },
    data() {
      return {
        user: {},
        breadcrumbs: [],
        fields: null,
        editable: true,
        accessJournalDialog: false,
        actionPermissions: null,
        developers: [],
        refDevelopers: [],
        accessJournals: [],
        baseUrl: process.env.VUE_APP_BACK_URL
      }
    },
    computed: {
      showInitiativeGroupField() {
        if (this.user.initiative_group) {
          return true
        }

        return this.user.developer && Number(this.user.developer.id) === 71
      }
    },
    watch: {
      // при изменениях маршрута запрашиваем данные снова
      $route: 'fetchData'
    },
    created() {
      // загружаем данные, когда представление создано
      // и данные реактивно отслеживаются
      this.fetchData()
      this.scrollToTop()
      this.$store.dispatch('fetchCurrentUser')
    },
    methods: {
      ...mapMutations(['setLoading']),
      // подгрузка данных
      fetchData() {
        this.setLoading(true)
        User.get(this.$route.params.id).then((response) => {
          this.user = response.data
          this.accessJournals = this.user.user_access_journals
          this.setLoading(false)
          this.initFields()
          this.generateBreadcrumbs(this.user.transName)
        }).catch((error) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
          this.setLoading(false)
        })
      },
      // генерация хлебных крошек
      generateBreadcrumbs(name) {
        this.breadcrumbs = [
          {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
          {text: this.$i18n.t('Управление доступом'), disabled: false, href: Trans.currentLocaleUrl + '/users'},
          {text: this.$i18n.t('Просмотр пользователя'), disabled: true},
        ]
      },
      //
      initFields() {
        this.fields = {
          email: {
            name: 'email',
            showEdit: false,
            userId: this.user.id,
            fields: [
              {
                name: 'email',
                label: this.$i18n.t('Электронный адрес почты'),
                value: this.user.email,
                type: 'varchar'
              }
            ]
          },
          name: {
            name: 'name',
            showEdit: false,
            userId: this.user.id,
            fields: [
              {
                name: 'secondName',
                label: this.$i18n.t('Фамилия'),
                value: this.user.second_name,
                type: 'varchar'
              },
              {
                name: 'firstName',
                label: this.$i18n.t('Имя'),
                value: this.user.first_name,
                type: 'varchar'
              },
              {
                name: 'lastName',
                label: this.$i18n.t('Отчество'),
                value: this.user.last_name,
                type: 'varchar'
              }
            ]
          },
          nickName: {
            name: 'nickName',
            showEdit: false,
            userId: this.user.id,
            fields: [
              {
                name: 'nickName',
                label: this.$i18n.t('Логин'),
                value: this.user.nick_name,
                type: 'varchar'
              }
            ]
          },
          systemRoles: {
            name: 'systemRoles',
            showEdit: false,
            model: 'systemRoles',
            userId: this.user.id,
            fields: [
              {
                name: 'systemRoles',
                label: this.$i18n.t('Роль'),
                value: this.user.system_roles ? this.user.system_roles : [],
                type: 'references',
                multiple: true
              }
            ]
          },
          phone: {
            name: 'phone',
            showEdit: false,
            userId: this.user.id,
            fields: [
              {
                name: 'phone',
                label: this.$i18n.t('Телефон'),
                value: this.user.phone,
                type: 'varchar'
              }
            ]
          },
          department: {
            name: 'department',
            showEdit: false,
            model: 'department',
            userId: this.user.id,
            fields: [
              {
                name: 'department',
                label: this.$i18n.t('Отдел/департамент'),
                value: this.user.department,
                type: 'varchar'
              }
            ]
          },
          developer: {
            name: 'developer',
            showEdit: false,
            model: 'developer',
            userId: this.user.id,
            fields: [
              {
                name: 'developer',
                label: this.$i18n.t('Разработчик'),
                value: this.user.developer,
                type: 'references'
              }
            ]
          },
          initiativeGroup: {
            name: 'initiativeGroup',
            showEdit: false,
            model: 'initiativeGroup',
            userId: this.user.id,
            fields: [
              {
                name: 'initiativeGroup',
                label: this.$i18n.t('Инициативная группа'),
                value: this.user.initiative_group ? this.user.initiative_group : null,
                type: 'references'
              }
            ]
          },
          post: {
            name: 'post',
            showEdit: false,
            model: 'post',
            userId: this.user.id,
            fields: [
              {
                name: 'post',
                label: 'post',
                value: this.user.phone,
                type: 'references'
              }
            ]
          },
          citizenship: {
            name: 'citizenship',
            showEdit: false,
            model: 'citizenship',
            userId: this.user.id,
            fields: [
              {
                name: 'citizenship',
                label: 'citizenship',
                value: this.user.citizenship,
                type: 'references'
              }
            ]
          },
          sex: {
            name: 'sex',
            showEdit: false,
            model: 'sex',
            userId: this.user.id,
            fields: [
              {
                name: 'sex',
                label: 'sex',
                value: this.user.sex,
                type: 'references'
              }
            ]
          },
          birthDate: {
            name: 'birthDate',
            showEdit: false,
            userId: this.user.id,
            fields: [
              {
                name: 'birthDate',
                label: this.$i18n.t('Дата рождения'),
                value: this.user.birth_date ? moment(this.user.birth_date).format('YYYY-MM-DD') : '',
                type: 'date'
              }
            ]
          },
          password: {
            name: 'password',
            showEdit: false,
            userId: this.user.id,
            fields: [
              {
                name: 'password',
                type: 'password'
              }
            ]
          },
          address: {
            name: 'address',
            showEdit: false,
            model: 'address',
            userId: this.user.id,
            fields: [
              {
                name: 'address',
                label: this.$i18n.t('Адрес'),
                value: this.user.address,
                type: 'varchar'
              }
            ]
          },
          lockedSystemRolePermissions: {
            name: 'lockedSystemRolePermissions',
            showEdit: false,
            model: 'permissions',
            userId: this.user.id,
            fields: [
              {
                name: 'lockedSystemRolePermissions',
                label: this.$i18n.t('Заблокированные разрешения ролей'),
                value: this.user.locked_system_role_permissions ? this.user.locked_system_role_permissions : [],
                type: 'references',
                multiple: true
              }
            ]
          },
          permissions: {
            name: 'permissions',
            showEdit: false,
            model: 'permissions',
            userId: this.user.id,
            fields: [
              {
                name: 'permissions',
                label: this.$i18n.t('Дополнительные разрешения пользователя'),
                value: this.user.permissions ? this.user.permissions : [],
                type: 'references',
                multiple: true
              }
            ]
          },
        }
      },
      // изменение полей
      updateField(result) {
        if (result.status) {
          if (result.user) {
            this.user = result.user
          }

          this.fields[result.fieldName].showEdit = false
        }
      },
      handleFileUpload() {
        this.file = this.$refs.file.files[0]
        let formData = new FormData()

        formData.append('file', this.file)
        formData.append('id', this.user.id)

        User.updateAvatar(formData).then((response) => {
          this.user = response.data
        })
      },
      changeAvatar() {
        this.$refs.file.click()
      },
      // Прокручивание к началу страницы
      scrollToTop() {
        window.scrollTo(0, 0)
      },
      // Отмена карточки
      onCancel() {
        this.$router.push(Trans.i18nRoute({
          name: 'users'
        }))
      },
    }
  }
</script>
